import React from 'react';
import { client } from './src/apollo/client';
import { ApolloProvider } from '@apollo/client';
import GlobalFonts from './src/fonts/Fonts';

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => (
  <>
    {/* <GlobalFonts /> */}
    <ApolloProvider client={client}>{element}</ApolloProvider>
  </>
);
